import React from 'react';
import { Loading } from '@fasstech/middle-design-system';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures.jsx';
import SimulationWarrantiesGroupProtectionForm from './SimulationWarrantiesGroupProtectionForm.jsx';
import useGetSimulationWarrantiesGroupProtectionQuery from './hooks/useGetSimulationWarrantiesGroupProtectionQuery.js';

const SimulationWarrantiesGroupProtection = ({
  getMiddleText,
  getMiddleNumber,
  getMiddleBoolean
}) => {
  const { getSimulationWarrantiesGroupProtection, loading } =
    useGetSimulationWarrantiesGroupProtectionQuery();

  if (loading) {
    return <Loading />;
  }

  return (
    <SimulationWarrantiesGroupProtectionForm
      getSimulationWarrantiesGroupProtection={getSimulationWarrantiesGroupProtection}
      getMiddleText={getMiddleText}
      getMiddleNumber={getMiddleNumber}
      getMiddleBoolean={getMiddleBoolean}
    />
  );
};

export default withMiddleFeatures(SimulationWarrantiesGroupProtection);
